import React from "react";
import { FormProvider } from "react-hook-form";

import { AgreementAppForm } from "@modules/agreementApps/components";
import { useAgreementAppEditForm } from "./controller";
import { Paper } from "@mui/material";

export const EditAgreementApp = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } =
    useAgreementAppEditForm();

  return (
    <Paper style={{ padding: "16px" }}>
      <FormProvider {...methods}>
        <AgreementAppForm
          onSubmit={handleSubmit((data: any) => mutateAsync(data))}
          isSubmitting={isPending}
        />
      </FormProvider>
    </Paper>
  );
});
